// @flow
import { connect } from 'react-redux';
import I18n from '../../lib/i18n';
import { visibleSubscriptionsSelector } from '../../modules/Dashboard/reducer';
import { isLoadingSelector } from '../../modules/LoadingStatus/reducer';
import { fetchRioRequest } from '../../modules/Rio';
import PickLineForRioNumber from './PickLineForRioNumber';

import type { State } from '../../modules/reducers';
import type { StateProps, DispatchProps } from '../../components/common/PickLine/PickLine';

const mapStateToProps = (state: State): StateProps => ({
  confirmButtonText: I18n.t('Dashboard.ManageLines.getRioNumber'),
  loadingSelector: 'fetchRio',
  isLoading: isLoadingSelector(state, 'fetchRio'),
  subscriptions: visibleSubscriptionsSelector(state),
  title: I18n.t('Dashboard.GetRioNumber.selectSubscription'),
});

const mapDispatchToProps: DispatchProps = {
  onConfirm: fetchRioRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(PickLineForRioNumber);
